import { useEffect, useState } from 'react'
import { pic } from 'assets/Icons'
import { IMAGES } from 'configs/configs.js'
import { hasAccess } from 'helper/utils'
import { Icon } from 'assets/index'
import { KanbanCard, Tag, Trashcan, AlertTags, YellowTag } from './style'

interface ICardProps {
  id?: string
  name: string
  tags: any
  children?: any
  color: string

  onClick?(_param?: any): any
  isDragging?: boolean
  url?: any
  onTrash?: any
}
interface ILabel {
  value: string
  content: string
  icon?: string
  id?: string
}

export function Label(props: ILabel) {
  const { content, value, icon, id } = props
  const profPic = icon ? `${IMAGES.URL}/images/${icon}` : pic

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <span className="kc-name">{value}:</span>
      <div className="tooltip">
        <div className="kc-specialist">
          {id && id !== 'default' && (
            <img
              className="kc-picture"
              src={profPic}
              alt="profile"
              onError={(e) => {
                e.currentTarget.src = `${IMAGES.URL}/images/profile_placeholder.png`
                // caso a imagem não exista, exibe a imagem de perfil padrão
              }}
            />
          )}
          <span className="kc-span" data-tip data-for={`${id}-specialist`}>
            {id === 'default' ? 'Selecionar' : content}
          </span>
        </div>
        <span className="tooltiptext">{content}</span>
      </div>
    </div>
  )
}

export default function KanbanCardComponent(props: ICardProps) {
  const { name, tags, children, id, onTrash } = props
  const [updatedTags, setUpdatedTags] = useState<any>(tags)

  const hasAnalysisTag = tags?.some(
    (tag: { value: string }) => tag.value === 'Analisar'
  )

  const hasManualPaymentTag = tags?.some(
    (tag: { value: string }) => tag.value === 'Pagamento Manual'
  )

  useEffect(() => {
    if (hasAnalysisTag || hasManualPaymentTag) {
      // Remove a tag com value igual a "Analisar"
      const filteredTags = tags?.filter(
        (tag: { value: string }) =>
          tag.value !== 'Analisar' && tag.value !== 'Pagamento Manual'
      )
      setUpdatedTags(filteredTags)
      // Atualize o estado de tags sem a tag "Analisar"
    }
  }, [])
  // Atualize o estado de tags sem a tag "Analisar" e cria um boleano para rederizar em outro lugar
  const hasTag = hasAnalysisTag || hasManualPaymentTag
  const nameSize = () => {
    if (hasTag && onTrash) return 'small'
    if (onTrash) return 'medium'
    if (hasTag) return 'small'
    return 'default'
  }
  return (
    <div>
      {hasAccess('trash-remove-proposta') && onTrash && (
        <Trashcan
          id="trash-remove-proposta"
          data-tip
          data-for={`trashcan`}
          style={{ zIndex: 999 }}
          src={Icon('trash.svg')}
          onClick={() => {
            console.log(typeof id)
            onTrash(id)
          }}
        />
      )}

      <KanbanCard nameSize={nameSize()} {...props}>
        <div>
          {hasTag && (
            <AlertTags onTrash={onTrash}>
              {hasManualPaymentTag && <YellowTag>Manual</YellowTag>}
              {hasAnalysisTag && <YellowTag>Analisar</YellowTag>}
            </AlertTags>
          )}
          <div className="trash-row tooltip2">
            <p className="kc-name" data-tip data-for={`${id}-name`}>
              {name}
            </p>
            <span className="tooltiptext2">{name}</span>
          </div>
          <div className="kc-tags-container">
            {updatedTags?.map((tag: any, i: number) => {
              return (
                <div className="tooltip" key={`${tag.value}+${i}-${id}`}>
                  <Tag
                    data-tip
                    data-for={`${id}-${i}`}
                    background={tag.background}
                    color={tag.color}
                    className="tag"
                  >
                    {tag.value}
                  </Tag>
                  {tag.tooltip && (
                    <span className="tooltiptext">{tag.tooltip}</span>
                  )}
                </div>
              )
            })}
          </div>
        </div>

        {children}
      </KanbanCard>
    </div>
  )
}
